module.exports = __webpack_public_path__ + "img/client-profile-placeholder.08c74464.png";